import Errors from './Errors'

class Form {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   */
  constructor (data) {
    this.originalData = data

    for (let field in data) {
      this[field] = data[field]
    }

    this.errors = new Errors()
  }
  /**
   * Fetch all relevant data for the form.
   */
  data () {
    let data = {}

    for (let property in this.originalData) {
      data[property] = this[property]
    }

    return data
  }

  /**
   * Reset the form fields.
   */
  reset () {
    for (let field in this.originalData) {
      this[field] = ''
    }

    this.errors.clear()
  }

  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   */
  post (url, data, ct = 0) {
    return this.submit('post', url, data, ct)
  }

  /**
   * Send a PUT request to the given URL.
   * .
   * @param {string} url
   */
  put (url) {
    return this.submit('put', url)
  }

  /**
   * Send a PATCH request to the given URL.
   * .
   * @param {string} url
   */
  patch (url) {
    return this.submit('patch', url)
  }

  /**
   * Send a DELETE request to the given URL.
   * .
   * @param {string} url
   */
  delete (url) {
    return this.submit('delete', url)
  }

  /**
   * Submit the form.
   *
   * @param {string} requestType
   * @param {string} url
   * @param {string} data
   */
  submit (requestType, url, data = this.data(), ct) {
    var conTy, encTy, procesData
    if (ct === 1) {
      procesData = false
      conTy = false
      encTy = 'multipart/form-data'
    } else {
      conTy = 'application/x-www-form-urlencoded'
      encTy = false
      procesData = true
    }

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        enctype: encTy,
        crossDomain: true,
        contentType: conTy,
        type: requestType,
        dataType: 'json',
        data: data,
        processData: procesData,
        success: function (response) {
          resolve(response)
        },
        error: function (jqXHR, textStatus, errorThrown) {
          reject(textStatus)
        }
      })
    })
  }

  /**
   * Send a get_json request to the given URL.
   * .
   * @param {string} url
   */
  getJson (url) {
    return this.getjson(url)
  }

  /**
   * GetJSON the form.
   *
   * @param {string} requestType
   * @param {string} url
   * @param {string} data
   */
  getjson (url) {
    return new Promise((resolve, reject) => {
      $.getJSON(url, function (response) {

      })
        .done(function (response) {
          resolve(response)
        })
        .fail(function (error) {
          reject(error)
        })
    })
  }

  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
  onSuccess (data) {
    console.log('uspeh')
    //  this.reset();
  }

  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail (errors) {
    alert(errors)
    this.errors.record(errors)
  }

  /**
   * Check if send fields are empty
   * @param obj
   */
  checkIfEmpty (obj) {
    var err = {}
    for (var key in obj) {
      if (obj[key] === '') {
        err[key] = 'required' // store.state.main.translate[lang].main.required;
        this.errors.record(err)
      }
    }
  }

  /**
   * @TODO REgex
   * Check if email is valid or not
   * @param obj
   */
  validateEmail (obj) {
    // var err = {}
    // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    //
    // for (var key in obj) {
    //   if (!re.test(obj[key])) {
    //     err[key] = 'email invalid' // this.store.state.main.translate[lang].main.email_invalid;
    //     this.errors.record(err)
    //   }
    // }
  }

  /**
   * Check length of sting. Used for password.
   *
   * @param {string} obj
   * @param {string} min
   * @param {string} max
   */
  minPasswordLength (obj, min = 8, max = 16) {
    var err = {}
    for (var key in obj) {
      if (obj[key].length < 8 || obj[key].length > 16) {
        err[key] = 'pass length' // this.store.state.main.translate[lang].main.min_max_pass;
        //  this.errors.record(err);
      }
    }
  }

  /**
   *
   * @param password
   * @param confirm_password
   */
  checkPasswordMatch (password, confirmPassword) {
    var err = {}
    if (confirmPassword !== '' && password !== '' && confirmPassword !== password) {
      err['confirm_password'] = 'not match'
      this.errors.record(err)
    }
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/utilities/Form.js